// extracted by mini-css-extract-plugin
module.exports = {"sectionContent":"FeatureSection_sectionContent__wWKZX"};